export default __webpack_public_path__ + "static/media/auto-fix-high-dark.70ac451b.svg";